"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = useForwardDomRef;

var _react = _interopRequireDefault(require("react"));

function isProperRef(ref) {
  return ref && Object.prototype.hasOwnProperty.call(ref, "current");
}

function useForwardDomRef(ref, parentRef) {
  _react["default"].useLayoutEffect(function () {
    if (typeof parentRef === "function") {
      parentRef(ref.current);
    } else if (isProperRef(parentRef)) {
      // eslint-disable-next-line no-param-reassign
      parentRef.current = ref.current;
    }
  }, [parentRef, ref]);

  return function () {
    if (typeof parentRef === "function") {
      parentRef(null);
    } else if (isProperRef(parentRef)) {
      // eslint-disable-next-line no-param-reassign
      parentRef.current = null;
    }
  };
}
//# sourceMappingURL=useForwardDomRef.js.map